// extracted by mini-css-extract-plugin
export default {"allProducts":"allProducts_allProducts__UaxGU","allProducts__head":"allProducts_allProducts__head__3665F"};